<label *ngIf="label" class="col-3 col-offset-4 "><span *ngIf="isRequired"
                                                       class="label-asterisk">*</span> {{label}} </label>
<div
    class="col-3 col-offset-4 flex justify-content-center align-items-center mt-1 img-container"
    style="border: 1px dashed cornflowerblue; box-sizing: content-box; align-items: center;position:relative;"
    [style.width.px]="widthPx"
    [style.height.px]="heightPx"
>
    <p-fileUpload #fileUploader [hidden]="pictureSrc || disabled" class="" name="picture" customUpload="true"
                  (onSelect)="onFileSelected($event)" multiple="false" mode="basic" accept="image/*"
                  [showCancelButton]="false"
                  [showUploadButton]="false"
                  showUploadButton="false">
    </p-fileUpload>
    <ng-content select="[customUploadButton]"></ng-content>
    <p-button  class="img-delete-btn" (click)="removePicture()" *ngIf="pictureSrc && showRemove" icon="pi pi-times"
              [rounded]="true" severity="danger" size="small"></p-button>

    <img *ngIf="pictureSrc " class="col-12 p-0"  [ngStyle]="{'width.px': widthPx,'height.px':heightPx}"
         style="alignment: left" src="{{ pictureSrc }}" alt=""/>

</div>
<p-confirmDialog key="{{ imageUploaderConfirmDialogKey }}"></p-confirmDialog>
